{
    "COMPONENTS": {
        "BUSINESS_UNIT_ICON": {
            "NO_UNIT": "Keine Geschäftseinheit"
        },
        "DATE_TIME_CELL": {
            "NO_DATE": "Kein Datum"
        },
        "DOCUMENT_TYPE_ICON": {
            "NO_TYPE": "Kein Dokumenttyp"
        },
        "LOGOUT": "Abmelden",
        "LUV_CLAIM": "Product Information Library",
        "USER_INFO": {
            "GREETING": "Willkommen, {userName}",
            "MENU": {
                "OUTBOX": "Outbox",
                "CUSTOMER_SEARCH": "Kundensuche"
            }
        },
        "CUSTOMERS_SELECT": {
            "LABEL": "Kunden",
            "PLACEHOLDER": "Bitte Kunden auswählen"
        },
        "QUALITY_STATEMENT_TEMPLATE_SELECT": {
            "LABEL": "PDF-Template",
            "PLACEHOLDER": "Bitte ein PDF-Template auswählen"
        },
        "MAIL_SENDERS_SELECT": {
            "LABEL": "Absender*in",
            "PLACEHOLDER": "Absender*in auswählen",
            "NO_SENDERS": "Es wurden keine Absender gefunden."
        },
        "LANGUAGE_ITEMS_SELECT": {
            "LABEL": "Sprache",
            "PLACEHOLDER": "Bitte eine Sprache auswählen"
        },
        "COUNTRY_NAMES_SELECT": {},
        "CONTAMINANTS_SELECT": {
            "LABEL": "Contaminants",
            "PLACEHOLDER": "Bitte Contaminants auswählen",
            "NO_OPTIONS": "Keine Contaminants verfügbar"
        },
        "NUTRITION_STATEMENTS_SELECT": {
            "LABEL": "Statements",
            "PLACEHOLDER": "Bitte Statements auswählen",
            "NO_OPTIONS": "Keine Statements verfügbar"
        },
        "STATEMENT_OWNER": {
            "MANAGED_BY": "Verwaltet von {owner}",
            "LABEL_SUFFIX": "{label} · {owner}"
        },
        "NUTRITION_STATEMENT_CHIPS": {
            "TITLE": "Statements",
            "INFO_TOOLTIP": "Ausgewählte Statements werden bei der Erstellung eines Lehvoss-Statements übernommen."
        },
        "CONTAMINANT_CHIPS": {
            "TITLE": "Contaminants",
            "INFO_TOOLTIP": "Ausgewählte Contaminants werden bei der Erstellung eines Lehvoss-Statements übernommen."
        },
        "STEP_NAVIGATION": {
            "ITEMS": {}
        },
        "SELECT_ALL_BUTTON": {
            "LABEL": {
                "SELECT_ALL": "Alle auswählen",
                "DESELECT_ALL": "Alle löschen"
            }
        },
        "MAIN_NAVIGATION": {
            "ITEMS": {}
        },
        "CREATE_QUALITY_STATEMENT_BUTTON": {
            "LABEL": "Lehvoss-Statement erstellen",
            "HELPER_TEXT": "Erstellt ein Lehvoss-Statement mit {count} ausgewähltem Element | Erstellt ein Lehvoss-Statement mit {count} ausgewählten Elementen"
        },
        "QUALITY_STATEMENT_DOCUMENTS_SELECT": {},
        "MAIL_RECIPIENTS_INPUT": {
            "LABEL": "Empfänger*innen",
            "PLACEHOLDER": "Bitte E-Mail-Adresse(n) angeben",
            "MESSAGE": "Beispiel: \"customer{'@'}customer-url.de\""
        },
        "PRODUCT_INFO": {
            "PRODUCT_NUMBER": "Produkt Nr.: {productNumber}",
            "PRODUCT_CHANGE": "Produkt ändern"
        },
        "MAIL_LOG_ITEMS": {
            "TABLE_HEADER": {
                "DATE": "Datum",
                "CUSTOMER": "Kunde",
                "SENDER": "Absender",
                "FILES": "Dateien",
                "PRODUCTS": "Produkte",
                "STATUS": "Status",
                "ACTIONS": "Aktionen"
            },
            "DOCUMENT_TABLE_HEADER": {
                "FILE_NAME": "Dateiname",
                "DOCUMENT_TYPE": "Typ",
                "PRODUCTS": "Produkte",
                "ACTIONS": "Aktionen"
            },
            "TABLE_ROW": {
                "VIEW_DOCUMENT": "Dokument ansehen",
                "DOWNLOAD_DOCUMENT": "Dokument herunterladen",
                "PREVIEW_ERROR": "Beim Laden der Vorschau ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                "DOWNLOAD_ERROR": "Beim Herunterladen des Dokuments ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                "REGENERATE_QUALITY_STATEMENT_DOCUMENT": "Erneut senden",
                "REGENERATE_QUALITY_STATEMENT_ERROR": "Beim Vorbereiten des erneuten Sendens ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                "FILE_COUNT": "{count} Dateien | {count} Datei | {count} Dateien",
                "PRODUCT_COUNT": "{count} Produkte | {count} Produkt | {count} Produkte",
                "MORE_PRODUCTS": "+{count} weitere",
                "NO_PRODUCT": "Kein Produkt",
                "NO_SENDER": "Unbekannt",
                "SHOW_DOCUMENTS": "Dokumente anzeigen",
                "HIDE_DOCUMENTS": "Dokumente ausblenden",
                "DOCUMENTS_REGION": "Dokumente der Mail \"{subject}\" an {customer} vom {date}"
            },
            "MAIL_CONTENT": {
                "BUTTON_LABEL": "Mailinhalt anzeigen",
                "TITLE": "Mailinhalt",
                "RECIPIENT": "Empfänger",
                "SUBJECT": "Betreff",
                "TEXT": "Text",
                "NOT_AVAILABLE": "Nicht verfügbar"
            },
            "RESEND_MAIL": {
                "BUTTON_LABEL": "Mail erneut versenden",
                "REPLACE_CART_TITLE": "Offenen Warenkorb ersetzen?",
                "REPLACE_CART_TEXT": "Sie haben einen offenen Warenkorb. Beim erneuten Versenden dieser Mail wird er gelöscht und durch einen neuen Warenkorb mit den Dokumenten dieser Mail ersetzt. Das kann nicht rückgängig gemacht werden.",
                "REPLACE_CART_CONFIRM": "Warenkorb ersetzen",
                "REPLACE_CART_CANCEL": "Abbrechen",
                "NOTICE_TITLE": "Mail konnte nicht erneut versendet werden",
                "NOTICE_CLOSE": "Schließen",
                "NOT_RESENDABLE": "Diese Mail wurde nicht über den Warenkorb versendet und kann nicht erneut versendet werden.",
                "ERROR": "Beim erneuten Versenden der Mail ist ein Fehler aufgetreten. Ihr offener Warenkorb wurde nicht verändert. Bitte versuchen Sie es erneut."
            },
            "SEND_STATUS": {
                "SENT": "Gesendet",
                "NOT_SENT": "Nicht gesendet"
            }
        },
        "CHECKOUT": {
            "ADD_TO_CART_BUTTON": {
                "LABEL_ADD": "Hinzufügen",
                "LABEL_REMOVE": "Entfernen",
                "LABEL_ERROR": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
            },
            "CART_MENU_BUTTON": {
                "DOCUMENTS_COUNT": "{count} Dokumente | {count} Dokument | {count} Dokumente"
            },
            "CART_FLYOUT": {
                "EMPTY_CART": "Dein Warenkorb ist leer",
                "GO_TO_CART_LABEL": "Mit dem Checkout starten"
            },
            "GO_BACK_BUTTON": "Zurück"
        },
        "APP_UPDATE_BANNER": {
            "MESSAGE": "Eine neue Version von AutoQ ist verfügbar.",
            "BUTTON": "Jetzt aktualisieren"
        }
    },
    "VIEWS": {
        "MODULAR_QSW": {
            "NAVIGATION": {
                "LABEL_NEXT": "Weiter",
                "LABEL_PREVIOUS": "Zurück",
                "LABEL_FINISH": "Abschließen",
                "LABEL_BACK_TO_PRODUCT": "Zurück zum Produkt",
                "ERROR_MESSAGE": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
                "ERROR_RETRY_LABEL": "Erneut versuchen"
            },
            "PAGE_TITLES": {
                "SELECT_DATA": "Daten auswählen",
                "DOCUMENT_PREVIEW": "Dokumentenvorschau",
                "NUTRITION_STATEMENTS_EDITOR": "Statement Editor"
            },
            "ELEMENT_TITLES": {
                "DOCUMENT_SETTINGS": "Dokumenteneinstellungen",
                "DATA_SETTINGS": "Daten-Einstellungen",
                "CREATE_NEW_NUTRITION_STATEMENT": "Neues Statement erstellen",
                "CUSTOMIZATION": "Anpassungen",
                "CUSTOM_PCF_VALUE": "PCF-Wert",
                "RENDER_PCF_VALUE": "PCF-Wert erzeugen"
            },
            "ELEMENT_LABELS": {
                "ANNOTATIONS_ELEMENT": "Anmerkungen",
                "NUTRITION_STATEMENTS": "Statements",
                "CONTAMINANTS": "Contaminants",
                "RECIPIENTS": "E-Mail-Empfänger*innen",
                "CUSTOMER": "Kund*in",
                "LANGUAGE": "Sprache",
                "CUSTOM_PCF_VALUE": "PCF-Wert",
                "DOCUMENT_TEMPLATE": "PDF-Vorlage",
                "RENDER_PCF_VALUE": "PCF-Wert integrieren"
            },
            "REGENERATE_QUALITY_STATEMENT_CHANGES": {
                "LABEL": "Änderungen seit dem Original-Versand",
                "TOGGLE_LABEL": "Änderungen ein-/ausblenden",
                "TABLE_HEADER": {
                    "WHAT_CHANGED": "Was sich geändert hat",
                    "LAST_UPDATED": "Zuletzt geändert",
                    "FIELD": "Feld"
                },
                "GO_TO_FIELD": "Zum Feld springen"
            },
            "NUTRITION_STATEMENTS_EDITOR": {
                "LABELS": {
                    "RESET_NUTRITION_STATEMENT": "Zurücksetzen",
                    "NUTRITION_STATEMENT_NAME": "Statement-Name",
                    "NUTRITION_STATEMENT_TEXT": "Statement-Text",
                    "SAVE_ERROR": "Ihre Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut."
                }
            },
            "NEW_NUTRITION_STATEMENT": {
                "LABELS": {
                    "NAME": "Statement-Name",
                    "TEXT": "Statement-Beschreibung",
                    "DELETE": "Statement löschen",
                    "ADD": "Hinzufügen",
                    "CANCEL": "Abbrechen"
                },
                "VALIDATION": {
                    "NO_STATEMENTS": "Um fortzufahren, müssen Sie ein Contaminant, bestehendes Statement, ein neues Statement oder einen gültigen PCF-Wert angeben"
                }
            },
            "SUB_HEADER": {
                "TITLE": "Create a Lehvoss Statement for"
            }
        },
        "PRODUCT_SEARCH": {
            "HEADER": {
                "TEXT_SEARCH": {
                    "LABEL": "Suchen nach",
                    "PLACEHOLDER": "Produkt Nr. oder Name",
                    "BUTTON": "Produkt suchen"
                }
            },
            "RESULTS": {
                "ITEMS": {
                    "HEADER": {
                        "PRODUCT_NUMBER": "Produkt Nr.",
                        "PRODUCT": "Produktname",
                        "DESCRIPTION": "Beschreibung"
                    }
                },
                "NO_RESULTS": {
                    "HEADLINE": "Keine Produkte gefunden",
                    "TEXT": "Ihre Suchanfrage ergab keine Treffer. Bitte versuchen Sie es mit anderen Suchbegriffen.",
                    "RESET": "Suche zurücksetzen"
                }
            },
            "FILTER": {
                "RESET": {
                    "LABEL": "Filter zurücksetzen"
                },
                "DROPDOWN_FILTER": {
                    "LABEL": "Bitte auswählen"
                }
            },
            "META": {}
        },
        "PRODUCT_OVERVIEW": {
            "TABLE": {
                "HEADERS": {},
                "ACTIONS": {
                    "SELECT_PRODUCT": "Produkt auswählen"
                }
            },
            "NO_RESULTS": {},
            "SEARCH_PROMPT": {}
        },
        "ERROR_PAGE": {
            "TITLE": "Ooops! Etwas ist schiefgelaufen",
            "TEXT": "Wir entschuldigen uns, aber es scheint ein Fehler aufgetreten zu sein. Unser Team wurde benachrichtigt und arbeitet an der Lösung des Problems. In der Zwischenzeit können Sie:",
            "LINK": {
                "GO_HOME": "Zur Startseite zurückkehren",
                "GO_BACK": "Zurückgehen und es erneut versuchen",
                "CONTACT": "Unser Support-Team kontaktieren"
            }
        },
        "ERROR_NOT_FOUND": {
            "TITLE": "Nicht gefunden",
            "TEXT": "Die gesuchte Seite konnte nicht gefunden werden. Sie wurde möglicherweise verschoben, gelöscht, die URL ist falsch oder Sie haben keinen Zugriff.",
            "LINK": {
                "GO_HOME": "Zurück zur Homepage",
                "SEARCH": "Ein anderes Produkt suchen"
            }
        },
        "CUSTOMER_CREATE": {
            "FORM": {
                "LABELS": {
                    "CUSTOMER_NUMBER": "Kundennummer",
                    "CUSTOMER_NAME": "Kundenname",
                    "SUBMIT": "Neuen Kunden hinzufügen"
                }
            }
        },
        "PRODUCT_DETAIL": {
            "PRODUCT_INFO": {
                "LABEL_PRODUCT_NUMBER": "Produkt-Nr.",
                "LABEL_PRODUCT_AVAILABILITY": "Verfügbarkeit"
            },
            "PRODUCT_DOCUMENTS": {
                "LABELS": {
                    "SUPPLIER": "Lieferant",
                    "NO_SUPPLIER": "Kein Lieferant",
                    "LANGUAGE": "Sprache",
                    "OPEN": "Dokument ansehen",
                    "DOWNLOAD": "Dokument herunterladen",
                    "DOCUMENT_TYPE": "Dokumententyp",
                    "FILENAME": "Dateiname",
                    "CREATION_DATE": "Erstellungsdatum",
                    "TOGGLE_DOCUMENTS": "Dokumente anzeigen/verstecken",
                    "TOGGLE_LEHVOSS_STATEMENTS": "Lehvoss-Statement-Elemente anzeigen/verstecken",
                    "LOAD_ERROR": "Beim Laden der Dokumente ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                    "PREVIEW_ERROR": "Beim Laden der Vorschau ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                    "DOWNLOAD_ERROR": "Beim Herunterladen des Dokuments ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                    "WATERMARK_LABEL": "MUSTER",
                    "PCF": "PCF",
                    "NUTRITION_STATEMENTS": "Statements",
                    "CONTAMINANTS": "Contaminants"
                },
                "CATEGORIES": {
                    "SALES_DOCUMENTS": "Sales Documents",
                    "CONTROLLED_SUPPLIER_DOCUMENTS": "Controlled Supplier Documents",
                    "CONTROLLED_LEHVOSS_STATEMENTS": "Controlled Lehvoss Statements",
                    "OTHER": "Other"
                }
            },
            "HISTORY": {
                "LABEL": "History"
            }
        },
        "OUTBOX": {
            "TITLE": "Outbox",
            "PLACEHOLDER_TEXT": "Deine versendeten Dokumente und Statements erscheinen hier in Kürze.",
            "NO_RESULTS": {
                "HEADLINE": "Keine Aktivität gefunden",
                "FILTERED_TEXT": "Keine Aktivität entspricht deinen Filtern."
            },
            "FILTER": {
                "DATE_RANGE": {
                    "LABEL": "Zeitraum"
                },
                "RESET": "Filter zurücksetzen"
            },
            "TABLE": {
                "LABEL": "History",
                "TOGGLE_LABEL": "History ein-/ausklappen"
            },
            "STATISTICS": {
                "USER": "Benutzer",
                "LAST_SEND_DATE": "Zuletzt gesendet",
                "CUSTOMER_COUNT": "Kontaktierte Kunden",
                "SENT_COUNT": "Erfolgreich gesendet",
                "NOT_SENT_COUNT": "Fehlgeschlagen",
                "DOCUMENT_CATEGORIES": "Dokumente nach Kategorie",
                "EMPTY_VALUE": "–"
            }
        },
        "CUSTOMER_SEARCH": {
            "TITLE": "Kundensuche",
            "NO_RESULTS": {
                "HEADLINE": "Keine Kunden gefunden",
                "TEXT": "Es sind noch keine Kunden vorhanden.",
                "FILTERED_TEXT": "Kein Kunde entspricht deiner Suche."
            },
            "FILTER": {
                "FULLTEXT": {
                    "LABEL": "Suche",
                    "PLACEHOLDER": "Kundenname oder -nummer"
                },
                "HAS_ACTIVITY": {
                    "LABEL": "Kunde hat Aktivität"
                },
                "RESET": "Filter zurücksetzen"
            },
            "TABLE": {
                "LABEL": "Kunden",
                "TOGGLE_LABEL": "Kunden ein-/ausklappen",
                "NO_ACTIVITY": "Keine Aktivität",
                "HEADER": {
                    "CUSTOMER_NAME": "Kundenname",
                    "CUSTOMER_NUMBER": "Kundennummer",
                    "LAST_ACTIVITY": "Letzte Aktivität",
                    "ACTIONS": "Aktionen"
                },
                "ACTIONS": {
                    "SELECT_CUSTOMER": "Kunde auswählen",
                    "SELECT_CUSTOMER_NAMED": "Kunde {name} auswählen"
                }
            }
        },
        "CUSTOMER_DETAIL": {
            "ADDRESS": "Adresse",
            "EMAIL": "E-Mail",
            "LAST_ACTIVITY": "Letzte Aktivität",
            "NO_ACTIVITY": "Keine Aktivität",
            "ACTIVITY_COUNT": "Anzahl der Aktivitäten",
            "NO_ACTIVITY_COUNT": "Noch nicht verfügbar",
            "LOAD_ERROR": {
                "HEADLINE": "Kunde konnte nicht geladen werden",
                "TEXT": "Die Kundendaten konnten nicht geladen werden. Bitte versuche es erneut.",
                "RETRY": "Erneut versuchen"
            },
            "HISTORY": {
                "LABEL": "History",
                "TOGGLE_LABEL": "History ein-/ausklappen",
                "FILTER": {
                    "PRODUCT_NUMBER": {
                        "LABEL": "Produktnummer"
                    },
                    "PRODUCT_NAME": {
                        "LABEL": "Produktname"
                    },
                    "CONTENT": {
                        "LABEL": "Typ",
                        "PLACEHOLDER": "Typ auswählen"
                    },
                    "EMAIL": {
                        "LABEL": "E-Mail-Adresse"
                    },
                    "DATE_RANGE": {
                        "LABEL": "Zeitraum"
                    },
                    "RESET": "Filter zurücksetzen"
                },
                "LOAD_ERROR": {
                    "TEXT": "Die Aktivitätshistorie konnte nicht geladen werden.",
                    "RETRY": "Erneut versuchen"
                },
                "EMPTY": {
                    "TEXT": "An diesen Kunden wurden noch keine Dokumente gesendet."
                },
                "NO_RESULTS": {
                    "FILTERED_TEXT": "Keine Aktivität entspricht deinen Filtern."
                },
                "DOCUMENT_TYPE": {
                    "NO_TYPE": "Kein Dokumenttyp"
                }
            }
        },
        "SEND_DOCUMENT_WIZARD": {
            "PREVIEW": {
                "NO_RESULTS": {},
                "NO_DOCUMENT_IDS": {},
                "FOOTER": {}
            },
            "SEND": {},
            "SUCCESS": {},
            "FAILED": {},
            "ROUTE_SWITCH": {}
        },
        "CHECKOUT": {
            "SUB_HEADER": {
                "HEADLINE": "Dokumentenwarenkorb",
                "DOCUMENTS_COUNT": "{count} Dokument im Warenkorb | {count} Dokument im Warenkorb | {count} Dokumente im Warenkorb",
                "BACK_BUTTON_LABEL": "Warenkorb verlassen"
            },
            "CART_OVERVIEW": {
                "REMOVED_DOCUMENTS": {
                    "TITLE": "Dokument nicht mehr verfügbar und nicht in den Warenkorb übernommen | {count} Dokument ist nicht mehr verfügbar und wurde nicht in den Warenkorb übernommen | {count} Dokumente sind nicht mehr verfügbar und wurden nicht in den Warenkorb übernommen",
                    "UNKNOWN_DOCUMENT": "Unbekanntes Dokument (ID {id})"
                },
                "DOCUMENTS_HEADLINE": "Dokumente",
                "DOCUMENTS_UPLOAD_HEADLINE": "Dokumente hochladen",
                "CUSTOM_DOCUMENTS_HEADLINE": "Hochgeladene Dokumente",
                "SUBMIT_BUTTON_LABEL": "Absenden",
                "ATTACHMENTS_TOO_LARGE_MESSAGE": "Die ausgewählten Dokumente sind zusammen zu groß für eine E-Mail ({size} MB von max. {maxSize} MB). Bitte entfernen Sie einige Dokumente und senden Sie erneut ab.",
                "MAIL_SIZE_HINT": "Pro E-Mail sind maximal {maxSize} MB möglich. Aktuell: {size} von {maxSize} MB.",
                "MAIL_SENDER": {
                    "SUBJECT_LABEL": "E-Mail-Betreff",
                    "BODY_LABEL": "E-Mail-Text",
                    "SAVE_BUTTON_LABEL": "Speichern"
                }
            },
            "CART_META_DATA": {
                "PREDEFINED_DOCUMENTS": {
                    "HEADLINE": "Lehvoss Dokumente"
                },
                "CUSTOMER_SELECT": {
                    "ADD_CUSTOMER": "Neuen Kunden hinzufügen"
                },
                "FOOT_NOTE": {
                    "REQUIRED": "Pflichtfeld"
                }
            },
            "SUCCESS_PAGE": {
                "HEADLINE": "Dokumente wurden versendet",
                "SUB_HEADLINE": "Deine Dokumente wurden erfolgreich versendet"
            },
            "ERROR_PAGE": {
                "HEADLINE": "Es gab ein Problem",
                "SUB_HEADLINE": "Bitte versuche es später erneut"
            },
            "CART_IS_EMPTY": {
                "HEADLINE": "Dein Warenkorb ist leer",
                "SUB_HEADLINE": "Bitte füge  mindestens 1 Dokument hinzu oder lade  ein Dokumente hoch"
            },
            "CREATE_CUSTOMER": {
                "SUB_HEADER": {
                    "BACK_BUTTON": "Zurück ohne Speichern"
                }
            }
        }
    },
    "validations": {
        "required": "Bitte ausfüllen!",
        "requiredHtml": "Bitte ausfüllen!",
        "maxLength": "Bitte nicht mehr als {max} Zeichen angeben!",
        "customerExists": "Ein Kunde mit dieser Kundennummer existiert bereits!",
        "emailFragment": "Bitte eine gültige E-Mail-Adresse oder einen Teil davon eingeben!"
    },
    "VALIDATION": {
        "ERROR": {
            "ARRAY_MIN": "{label} muss mindestens {count} Elemente enthalten",
            "OBJECT_UNKNOWN": "{label} ist hier nicht erlaubt",
            "OBJECT_BASE": "{label} muss ausgewählt werden",
            "ANY_REQUIRED": "{label} ist ein Pflichtfeld",
            "ANY_ONLY": "{label} muss ausgewählt werden",
            "NUMBER_BASE": "{label} muss eine Zahl sein",
            "NUMBER_MIN": "{label} muss mindestens {count} sein",
            "ARRAY_INCLUDESREQUIREDUNKNOWNS": "{label} enthält nicht das gewünschte Format",
            "STRING_EMPTY": "{label} darf nicht leer sein",
            "ANY_INVALID": "{label} enthält einen ungültigen Wert"
        }
    }
}
